(function () {
  const popup = document.getElementById('videoPopup');

  if (window.videoPopupInitialized) {
    if (popup) popup.remove();
    return;
  }
  window.videoPopupInitialized = true;

  if (popup) document.body.appendChild(popup);

  function updateUrlWithProduct(productHandle) {
    if (!productHandle) return;
    const url = new URL(window.location);
    url.searchParams.set('product', productHandle);
    window.history.pushState({}, '', url);
  }

  function clearProductFromUrl() {
    const url = new URL(window.location);
    if (url.searchParams.has('product')) {
      url.searchParams.delete('product');
      window.history.pushState({}, '', url);
    }
  }

  function openPopup(videoUrl, posterUrl, productHandle, autoplay = false) {
    const popup = document.getElementById('videoPopup');
    const video = popup.querySelector('.video-popup__video');
    const source = video.querySelector('source');
    const poster = popup.querySelector('.video-popup__poster');
    const posterImg = popup.querySelector('.video-popup__poster-img');

    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = scrollbarWidth + 'px';
    document.body.style.overflow = 'hidden';

    popup.style.removeProperty('opacity');
    popup.style.removeProperty('visibility');

    source.src = videoUrl;
    video.load();

    if (posterUrl && !autoplay) {
      posterImg.src = posterUrl;
      poster.classList.add('active');
    } else {
      poster.classList.remove('active');
    }

    popup.classList.add('active');
    document.body.classList.add('video-popup-open');

    updateUrlWithProduct(productHandle);

    if (autoplay) {
      video.play();
    }
  }

  function playVideo() {
    const popup = document.getElementById('videoPopup');
    const video = popup.querySelector('.video-popup__video');
    const poster = popup.querySelector('.video-popup__poster');

    poster.classList.remove('active');
    video.play();
  }

  function closePopup() {
    const popup = document.getElementById('videoPopup');
    const video = popup.querySelector('.video-popup__video');
    const poster = popup.querySelector('.video-popup__poster');

    popup.classList.remove('active');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    video.pause();
    video.currentTime = 0;

    clearProductFromUrl();

    setTimeout(() => {
      document.body.classList.remove('video-popup-open');
      poster.classList.add('active');
    }, 300);
  }

  document.addEventListener('click', function (e) {
    const videoBtn = e.target.closest('.new-product__video-btn, .how-to-use__item-img-wrapper');
    if (videoBtn) {
      const videoUrl = videoBtn.dataset.videoUrl;
      const posterUrl = videoBtn.dataset.posterUrl;
      const parentItem = videoBtn.closest('.how-to-use__item');
      const productHandle = parentItem ? parentItem.dataset.productHandle : null;
      if (videoUrl) openPopup(videoUrl, posterUrl, productHandle, true);
      return;
    }

    if (e.target.closest('.video-popup__poster')) {
      playVideo();
      return;
    }

    if (e.target.closest('.video-popup__close')) {
      closePopup();
      return;
    }

    const popup = document.getElementById('videoPopup');
    if (popup && popup.classList.contains('active')) {
      if (!e.target.closest('.video-popup__content')) {
        closePopup();
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    const popup = document.getElementById('videoPopup');
    if (e.key === 'Escape' && popup && popup.classList.contains('active')) {
      closePopup();
    }
  });

  window.videoPopup = { open: openPopup, close: closePopup };

  // Auto-open popup from URL parameter (skip on product pages)
  function initFromUrl() {
    const isProductPage = window.location.pathname.includes('/products/');
    if (isProductPage) return;

    const urlParams = new URLSearchParams(window.location.search);
    const productHandle = urlParams.get('product');

    if (productHandle) {
      const targetItem = document.querySelector(`.how-to-use__item[data-product-handle="${productHandle}"]`);
      if (targetItem) {
        const wrapper = targetItem.querySelector('.how-to-use__item-img-wrapper');
        if (wrapper && wrapper.dataset.videoUrl) {
          openPopup(wrapper.dataset.videoUrl, wrapper.dataset.posterUrl, productHandle);
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromUrl);
  } else {
    initFromUrl();
  }
})();
